// extracted by mini-css-extract-plugin
module.exports = {"background":"Modal_background__mOWl_","modalWrapper":"Modal_modalWrapper__1DF1M"};